import { Builder } from '@builder.io/react'
import dynamic from 'next/dynamic'

Builder.registerComponent(
    dynamic(() => import('../forms/HubspotLeadsForm').then((res) => res)),
    {
        name: 'Hubspot Leads Form',
    }
)
